<template>
    <div>
        <div class="text-right mb-4 mt-5">
            <v-btn class="text-none text-center default-button" @click="openCreateModal">
                <v-icon class="mr-1" color="white" dense>
                    add
                </v-icon>
                Ajouter un moyent de paiement
            </v-btn>
        </div>

        <v-simple-table class="mt-5">
            <thead>
            <tr>
                <th class="text-left border-0" width="25px"></th>
                <th class="text-left">Nom</th>
                <th class="text-left">Statut</th>
                <th class="text-right">Actions</th>
            </tr>
            </thead>
            <draggable v-model="options"
                       tag="tbody"
                       handle=".drag-handle"
                       :scroll-sensitivity="200"
                       :force-fallback="true"
                       :options="{
                            animation: 200,
                            ghostClass: 'sortable-ghost',
                            chosenClass: 'sortable-chosen'
                       }"
                       @start="setCopyPaymentOptions"
                       @end="onDragEnd"
                       @change="reorderPaymentOptions">
                <tr v-for="option in options">
                    <td class="border-0">
                        <v-icon class="drag-handle page__grab-icon" color="gray">mdi-drag</v-icon>
                    </td>
                    <td>
                        <button @click="openUpdateModal(option)" class="text-primary">
                            {{ option.label }}
                        </button>
                        <v-chip v-if="option.code === 'CB' && cadhConfig.account.e_payment_configured"
                                class="ml-4" color="green" small>
                            <span class="text-white">Configuré</span>
                        </v-chip>
                        <v-chip v-else-if="option.code === 'CB' && !cadhConfig.account.e_payment_configured"
                                class="ml-4" color="red" small>
                            <span class="text-white">Non configuré</span>
                        </v-chip>
                    </td>
                    <td>{{ option.enabled ? "Actif" : "Masqué" }}</td>
                    <td class="text-right">
                        <v-tooltip bottom v-if="isOptionDeletable(option) && !usedInCampaign">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small
                                       icon
                                       v-on="on"
                                       class="custom-button-error mr-2"
                                       @click="deletePaymentOption(option.id)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Supprimer</span>
                        </v-tooltip>

                        <v-btn small icon color="primary" class="custom-button-error mr-2"
                               v-else-if="(option.code === 'VIR' || option.code === 'SEPA')
                               && option.document !== '' && option.document !== null">
                            <a
                              :href="option.document"
                              target="_blank"
                            >
                                <v-icon>find_in_page</v-icon>
                            </a>
                        </v-btn>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small icon v-on="on" color="primary" class="custom-button-error"
                                       @click="openUpdateModal(option)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </template>
                            <span>Modifier</span>
                        </v-tooltip>

                    </td>
                </tr>
                <tr class="sortable-chosen sortable-fallback sortable-drag" draggable="true"
                    style="box-sizing: border-box; margin: 0; top: 3443px; left: 252px; width: 1588px; height: 48px; opacity: 0.8; position: fixed; z-index: 110000; pointer-events: none; transform-origin: 1.8016%; transform: matrix(1, 0, 0, 1, 33, 12)">
                    <td class="border-0">
                        <v-icon class="drag-handle page__grab-icon" color="gray">mdi-drag</v-icon>
                    </td>
                    <td>ok</td>
                    <td>ok1</td>
                    <td>ok2</td>
                </tr>
            </draggable>
        </v-simple-table>

        <v-dialog ref="dialog" v-model="paymentOptionModal" persistent width="900px">
            <create-payment-option-modal
              :paymentOption="selectedPaymentOption"
              :mode="modalMode"
            ></create-payment-option-modal>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import CreatePaymentOptionModal from "./CreatePaymentOptionModal.vue"
import Confirm from "../../tools/Confirm.vue"
import draggable from "vuedraggable"
import draggableMixin from "@/mixins/draggableMixin"

export default {
    name: "CadhConfigMeansOfPayment",
    components: { CreatePaymentOptionModal, Confirm, draggable },
    mixins: [draggableMixin],
    data() {
        return {
            selectedPaymentOption: {},
            modalMode: null,
            copyPaymentOptions: [],
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setPaymentOptionModal"]),
        openUpdateModal(paymentOption) {
            this.selectedPaymentOption = JSON.parse(JSON.stringify(paymentOption))
            this.modalMode = "update"
            this.setPaymentOptionModal(true)
        },
        openCreateModal() {
            this.selectedPaymentOption = {
                "label": "",
                "description": "",
                "enabled": true,
            }
            this.modalMode = "create"
            this.setPaymentOptionModal(true)
        },
        deletePaymentOption(id) {
            this.$refs.confirm.open("Attention",
              "Voulez-vous vraiment supprimer ce moyen de paiement ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$store.dispatch("cadhConfig/deletePaymentOption", id)
                }
            })
        },
        setCopyPaymentOptions(event) {
            this.copyPaymentOptions = JSON.parse(JSON.stringify(this.options))

            this.onDragStart(event)
        },
        reorderPaymentOptions(event) {
            if (event.moved) {
                const pointerType = event.moved.newIndex !== this.options.length - 1 ? "before" : "after"
                const moveObject = event.moved.element.id
                const pointerId = this.copyPaymentOptions[event.moved.newIndex].id

                this.$store.dispatch("cadhConfig/reorderList", [
                    "cadh_payment_options",
                    this.cadhConfig.id,
                    pointerId,
                    pointerType,
                    moveObject,
                ]).then(res => {
                    this.options = res.body.data.items
                })
            }
        },
        isOptionDeletable(option) {
            return !["CB", "VIR", "SEPA"].includes(option.code)
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "paymentOptionModal", "paymentOptions", "usedInCampaign"]),
        options: {
            get() {
                return this.paymentOptions
            },
            set(value) {
                this.$store.commit("cadhConfig/setPaymentOptions", value)
            },
        },
    },
}
</script>